/**
 * Script per la pulizia dei testi rimuovendo i riferimenti ai paragrafi
 * Rimuove tutte le parentesi che contengono la parola "paragrafo"
 */

export function cleanParagraphReferences(text) {
  // Regex per trovare parentesi che contengono "paragrafo" o "vedere paragrafo"
  // Questa regex cattura:
  // - (vedere paragrafo "...")
  // - (elencati al paragrafo ...)
  // - (vedere paragrafo 2)
  // - qualsiasi variazione con "paragrafo" dentro parentesi
  const paragraphRegex = /\s*\([^)]*paragrafo[^)]*\)/gi;

  // Rimuove le parentesi con riferimenti ai paragrafi
  let cleanedText = text.replace(paragraphRegex, '');

  // Pulisce gli spazi multipli e i punti e virgola doppi
  cleanedText = cleanedText
    .replace(/\s+/g, ' ') // Sostituisce spazi multipli con uno singolo
    .replace(/;\s*;/g, ';') // Rimuove punti e virgola doppi
    .replace(/,\s*,/g, ',') // Rimuove virgole doppie
    .replace(/\.\s*\./g, '.') // Rimuove punti doppi
    .replace(/\s+([,.;:])/g, '$1') // Rimuove spazi prima di punteggiatura
    .replace(
      'https://www.aifa.gov.it/content/segnalazionireazioni-avverse',
      'https://www.aifa.gov.it/content/segnalazioni-reazioni-avverse'
    )
    .trim();

  return cleanedText;
}
